import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { CustomLoginData, IAuthState } from './types';

const initialState: IAuthState = {
  accessToken: null,
  refreshToken: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCustomLoginData: (state, action: PayloadAction<CustomLoginData>) => {
      return { ...state, ...action.payload };
    },
    resetCustomLoginDataSuccess: () => initialState,
  },
});

export const { setCustomLoginData, resetCustomLoginDataSuccess } =
  authSlice.actions;
export const authReducer = authSlice.reducer;

export default authSlice;
